import React from 'react';
import { connect } from 'react-redux';

import TravelButton from 'components/TravelButton';
import { IArea } from "types/map";
import { IAppState } from "types/app";

function WelcomeAndTravel(props: Props) {
  const { profileName, currentArea } = props;
  if (!(profileName && currentArea)) {
    return null;
  }
  return (
    <div className="storylets__welcome-and-travel">
      <div className="heading heading--2">
        It's
        {' '}
        <span dangerouslySetInnerHTML={{ __html: profileName }} />
        !
        {' '}
        {`Welcome to ${currentArea.name}, delicious friend!`}
      </div>
      <TravelButton />
    </div>
  );
}

interface Props {
  currentArea?: IArea,
  profileName?: string | undefined,
}

const mapStateToProps = ({
  map: { canTravel, currentArea },
  myself: { character: { name: profileName } },
  storylet: { phase },
}: IAppState) => ({
  canTravel,
  currentArea,
  profileName,
  phase,
});

export default connect(mapStateToProps)(WelcomeAndTravel);